import { FieldPath, useFormContext } from "react-hook-form";

import { Checkbox } from "@/components/ui/checkbox";
import { CityInput } from "types";
import { ComponentProps } from "react";
import { FormField } from "@/components/ui/form";

const SIMPLE_OPTIONS: { id: string; path: FieldPath<CityInput>; label: string; description: string }[] = [
  {
    id: "live",
    path: "options.live",
    label: "Temps réel",
    description: "Active la disponibilité du stationnement en temps réel dans la ville.",
  },
  {
    id: "offstreet",
    path: "options.offstreet",
    label: "Hors voirie",
    description: "Active le stationnement hors voirie pour la ville.",
  },
  {
    id: "payment",
    path: "options.payment",
    label: "Paiement mobile",
    description: "Active le paiement du stationnement depuis l'application mobile.",
  },
  {
    id: "curbZones",
    path: "options.curbZones",
    label: "Carte des places",
    description: "Active l'accès à la carte des places dans Simon.",
  },
  {
    id: "mapIntegration",
    path: "options.mapIntegration",
    label: "Intégration web",
    description: "Active l'intégration de la carte des places sur le site web du client (iframe).",
  },
  {
    id: "mobileMap",
    path: "options.mobileMap",
    label: "Carte mobile",
    description: "Active l'affichage de la carte des places dans l'application mobile.",
  },
];

const OptionCheckbox = ({
  id,
  label,
  description,
  checked,
  onCheckedChange,
}: {
  id: string;
  label: string;
  description: string;
  checked: boolean;
  onCheckedChange: ComponentProps<typeof Checkbox>["onCheckedChange"];
}) => (
  <div className="flex items-start space-x-2">
    <Checkbox checked={checked} onCheckedChange={onCheckedChange} id={id} className="mt-0.5" />
    <div className="flex flex-col gap-0.5">
      <label htmlFor={id} className="text-sm font-medium leading-none">
        {label}
      </label>
      <span className="text-xs text-muted-foreground leading-snug">{description}</span>
    </div>
  </div>
);

export const CityOptions = () => {
  const { control } = useFormContext<CityInput>();

  return (
    <div className="px-4 pt-4 pb-2 text-sm">
      <div className="grid grid-cols-2 w-full gap-x-6 gap-y-4">
        {SIMPLE_OPTIONS.map(({ id, path, label, description }) => (
          <FormField
            key={id}
            control={control}
            name={path}
            render={({ field }) => (
              <OptionCheckbox
                id={id}
                label={label}
                description={description}
                checked={!!field.value}
                onCheckedChange={field.onChange}
              />
            )}
          />
        ))}
      </div>
    </div>
  );
};
